import React from "react";
import { graphql } from "gatsby";
import {
  ImageButton,
} from "@zempler/theme/src/components/buttons/imageButton/ImageButton";

export const ButtonBarImageLink = ({ data, ...rest }) => <ImageButton link={data.link} imageSrc={data?.image?.image?.localFile} imageAlt={data?.image?.image?.altText} />

export const ButtonBarImageLinkQuery = graphql`
  fragment ButtonBarImageLink on UMBRACO_ButtonBarImageLinkComponentType {
    image {
      image {
        altText
        ...ButtonBarImage
      }
    }
    link {
      ...Link
    }
  }
`;
